export default __webpack_public_path__ + "static/media/logo-samsung-well.f6aebcd9.png";